module.exports = __webpack_public_path__ + "kkr-c0bd8df2ad0806a4a36f.png";